import pickShiftStepUrl from './pick-shift-step.html';

class PickShiftStepCtrl {
  constructor(sdk) {
    'ngInject';

    Object.assign(this, { sdk });
  }

  $onInit() {
    const { location, position } = this.originalShift;
    this.filteredShiftGroups = this.sdk('groupByLocationAndPosition')(
      this.shifts,
      location.id,
      position.id
    );
  }

  onShiftSelect(selectedShift) {
    this.selectedShift = selectedShift;
    this.onSelect({ shift: selectedShift });
  }
}

export default {
  controller: PickShiftStepCtrl,
  controllerAs: 'ctrl',
  bindings: {
    originalShift: '<', // shift that swap was initialized on
    shifts: '<',
    onSelect: '&',
  },
  templateUrl: pickShiftStepUrl,
};
